import { styled } from '@mui/material';
import offlineErrorIcon from '/assets/image/offline-error.svg';
import { useOfflineMode } from '~/contexts/OfflineModeContext';
import { TOP_NAV } from '~/layouts/Layout/Layout.style';

const Banner = styled('div')(() => ({
  position: 'fixed',
  top: TOP_NAV,
  right: 0,
  left: 0,
  zIndex: 2,
  height: '40px',
  background: '#FF4842',
  color: '#FFFFFF',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '32px',
  boxSizing: 'border-box',
  padding: '8px 12px 8px 16px',
  fontSize: '16px',
  lineHeight: '22px',
  fontWeight: 500,
}));

const Message = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  height: '24px',
  // 視窗被縮窄時優先壓縮訊息、必要時以刪節號截斷，讓「再試一次」不會被擠出
  // 畫面——那是離線狀態下唯一的手動恢復入口。
  minWidth: 0,
  overflow: 'hidden',
  '& span': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

const ErrorIcon = styled('img')(() => ({
  display: 'block',
  width: '24px',
  height: '24px',
  flex: '0 0 24px',
}));

const RetryButton = styled('button')(() => ({
  minWidth: 0,
  // 永遠不被壓縮，確保按鈕完整可見可點
  flex: '0 0 auto',
  border: 0,
  padding: '6px 14px',
  borderRadius: '8px',
  background: '#FFFFFF',
  color: '#212B36',
  fontSize: '14px',
  lineHeight: 'normal',
  fontWeight: 400,
  letterSpacing: '0.7px',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  '&:hover': {
    background: '#F4F6F8',
  },
  '&:disabled': {
    cursor: 'default',
    opacity: 0.7,
  },
}));

export const OfflineBanner = () => {
  const { isRetrying, retryConnection } = useOfflineMode();

  return (
    <Banner role="status">
      <Message>
        <ErrorIcon src={offlineErrorIcon} alt="" aria-hidden="true" />
        <span>
          目前無法連線僅能使用已下載完成的資源，恢復連線後即可使用完整功能
        </span>
      </Message>
      <RetryButton
        type="button"
        disabled={isRetrying}
        onClick={() => void retryConnection()}
      >
        再試一次
      </RetryButton>
    </Banner>
  );
};
